import { render } from "./Lobby.vue?vue&type=template&id=62fdf116&scoped=true"
import script from "./Lobby.vue?vue&type=script&lang=js"
export * from "./Lobby.vue?vue&type=script&lang=js"

import "./Lobby.vue?vue&type=style&index=0&id=62fdf116&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62fdf116"]])

export default __exports__